<template>
  <div class="m-headingForT-play-now" @click="Util.playFree()">
    <div class="m-headingForT-play-now__cta-text">Play Now</div>
  </div>
</template>

<script setup>
  import Util from '@/services/browser/Util'
  import { defineProps } from 'vue'
  const props = defineProps({
    href: {
      type: String,
      required: true,
    },
  })
</script>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/DemonSlayerCollab/variables.scss' as *;
  .m-headingForT-play-now {
    cursor: pointer;
    width: 17vw;
    height: 5vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/hero/cta-btn/btn-bg.png') no-repeat center center /
      100% auto;
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    font-size: 2vw;
    transition: background 0.3s;
    &:hover,
    &:after {
      content: '';
      background-image: url('~@/assets/images/microsites/headingfortomorrow/hero/cta-btn/btn-bg-hover.png');
    }
  }
  .m-headingForT-play-now__cta-text {
    text-transform: uppercase;
    margin-bottom: 0.4vw;
  }
  .tablet {
    .m-headingForT-play-now {
      width: 39vw;
      height: 10vw;
      font-size: 4vw;
    }
  }
  .mobile {
    .m-headingForT-play-now {
      width: 83vw;
      height: 22vw;
      font-size: 10.5vw;
    }
  }
</style>
